"use strict";

define(['app', 'jquery', './base'], function (app, $, Helper) {
  return Helper.extend({
    ui: {
      link: '.js-mark-answer'
    },
    events: {
      'click @ui.link': 'markAnswer'
    },
    markAnswer: function markAnswer(e) {
      e.preventDefault();
      $.ajax(this.ui.link.attr('href'), {
        type: 'POST',
        success: function success() {
          window.location.reload(true);
        },
        error: function error() {
          window.location.reload(true);
        }
      });
    }
  });
});